// Helper to get studygroup name from studygroup_id
// This is needed because Person doesn't have a studygroup relation in the GraphQL schema
export const getStudygroupName = (
  studygroupId: string | number | undefined | null,
): string => {
  if (studygroupId === undefined || studygroupId === null || studygroupId === '') {
    return '–';
  }

  const idString = String(studygroupId);

  // Try to get from PersonStore if available
  if (typeof window !== 'undefined' && (window as any).person_store) {
    const personStore = (window as any).person_store;

    // If we have access to camp with studygroups data
    if (personStore.activeCamp) {
      // TODO: Implement studygroup lookup using personStore.activeCamp.studygroupCollection
      // For now, return the ID string as it might already be the name
      return idString;
    }
  }

  // Fallback to showing the ID string
  return idString;
};
